import { toReadableTime } from '@/utils/time'

export interface SleepPeriodVM {
  id: string
  sleepDateTs: number
  sleepTimeTs: number
  awakeTimeTs: number
  sleepDate: string
  sleepTime: string
  awakeTime: string
}

export function defaultSleepPeriodVM(): SleepPeriodVM {
  return {
    id: '',
    sleepDateTs: 0,
    sleepTimeTs: 0,
    awakeTimeTs: 0,
    sleepDate: '',
    sleepTime: '',
    awakeTime: '',
  }
}

export function toSleepPeriodVM(sleepPeriod: {
  sleepDate: number
  sleepTime: number
  awakeTime: number
}): SleepPeriodVM {
  const { sleepDate, sleepTime, awakeTime } = sleepPeriod
  return {
    id: Math.random()
      .toString(36)
      .slice(2),
    sleepDateTs: sleepDate,
    sleepTimeTs: sleepTime,
    awakeTimeTs: awakeTime,
    sleepDate: toReadableTime({ timestamp: sleepDate }),
    sleepTime: toReadableTime({ timestamp: sleepTime }),
    awakeTime: toReadableTime({ timestamp: awakeTime }),
  }
}
